<template>
  <div class="content">
    <head-title :title="title" class="title" v-if="title" />
    <div class="steps-container">
      <box-carousel>
        <div v-for="step in steps" :key="step.text" class="box-item">
          <div class="box-image" v-if="step.image.src">
            <img :src="getImage(step.image.src)" :alt="step.image.alt" />
          </div>
          <div class="box-text">
            {{ step.text }}
          </div>
        </div>
      </box-carousel>
    </div>
    <div class="steps-complement" v-if="text && subtext">
      <div class="text" v-if="text">
        <p>{{ text }}</p>
      </div>
      <div class="subtext" v-if="subtext">
        <p>{{ subtext }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import HeadTitle from "@/components/core/HeadTitle";
import BoxCarousel from "@/components/core/BoxCarousel.vue";

export default {
  name: "BoxSteps",
  components: {
    HeadTitle,
    BoxCarousel
  },
  props: {
    title: String,
    steps: Array,
    text: String,
    subtext: String,
    imgSrc: String
  },
  methods: {
    getImage(image) {
      return require(`@/${this.imgSrc}${image}`);
    }
  }
};
</script>
<style scoped>
.content {
  background-color: #f7f8f8;
  padding: 20px 16px;
  border-radius: 16px;
}
.title {
  font-size: 1.5rem;
  line-height: 2rem;
  margin-bottom: 16px;
}
.steps-container {
  margin-top: 40px;
  margin-bottom: 40px;
}
.steps-complement {
  text-align: center;
  margin-top: 34px;
}
.steps-complement p {
  margin: 10px 0;
}
.text {
  font-size: 1.25rem;
}
.text p {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}
.box-item {
  background-color: #fff;
  border-radius: 16px;
  padding: 25px;
}
.box-image {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  margin-bottom: 5px;
}
img {
  width: auto;
  height: auto;
  max-height: 64px;
  max-width: 100%;
}
.box-text {
  white-space: wrap;
  text-align: center;
}
@media screen and (min-width: 600px) {
  .content {
    padding: 42px 16px;
  }
  .title {
    font-size: 1.875rem;
    font-weight: 700;
    line-height: 2.425rem;
    margin: 10px 0 16px;
    text-align: center;
  }
  .steps-container {
    max-width: 75%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 50px;
    margin-bottom: 50px;
  }
  img {
    max-height: 120px;
  }
  .box-text {
    font-size: 1.25rem;
  }
}
</style>
